import styled from 'styled-components';
import { fontAccent } from 'Styles/fonts';

export const AccountGreeting = styled.div`
  ${fontAccent(20)};
  color: var(--foreground);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default {};
